import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Denounce } from '../../../core/models/denounce.model';
import { UtilsService } from '../../../core/services/utils.service';
import { AppState } from '../../../core/state/app.reducer';

import {
	MatDatepickerInputEvent,
	MatDateRangePicker,
} from '@angular/material/datepicker';
import { ToastrService } from 'ngx-toastr';
import {
	linesName,
	placeComplaint,
	placeComplaintDict,
	typeComplaintDict,
	typesComplaint,
} from '../../../../assets/complaintsDetail/complaintsInfo';
import { ComplaintConfirmationDeleteComponent } from '../../../components/modals/complaint-confirmation-delete/complaint-confirmation-delete.component';
import { ComplaintsService } from '../../../core/services/complaints.service';
import { UserService } from '../../../core/services/user.service';
import * as fromComplaintsActions from '../../home/state/complaints.actions';
import * as fromComplaintsSelector from '../../home/state/complaints.selectors';

@Component({
	selector: 'app-ocorrence-list',
	templateUrl: './ocorrence-list.component.html',
	styleUrls: ['./ocorrence-list.component.scss'],
})
export class OcorrenceListComponent implements OnInit {
	typesComplaint: string[] = typesComplaint;
	typeComplaintDict = typeComplaintDict;
	placeComplaintDict = placeComplaintDict;
	placeComplaint = placeComplaint;
	linesName: string[] = linesName;
	sublocalities: string[] = [];
	created_at_from_date_complaint: any;
	created_at_to_date_complaint: any;
	user_id_complaint: any;

	searchFilter: FormGroup;

	selectedOption = 'Todos';
	public currentYearDate = new Date();
	public currentYear = this.currentYearDate.getFullYear();
	public lastTwoWeeks: Date = null;
	public initialDate: Date = null;
	public lastWeek: Date | String = null;
	public endDate: Date = null;
	public barChartLabels = [`Todos os casos`];
	public selectedLabel = 'Todos';

	public showFilters: boolean = false;

	pageIndex: number = 0;
	pageSize: number = 5;

	setShowFilters = (value: boolean) => (this.showFilters = value);

	closeModal(event: MouseEvent): void {
		if (event.target === event.currentTarget) {
			this.setShowFilters(false);
		}
	}

	openDatePicker() {
		const datePickerInput = document.getElementById(
			'picker-toggle'
		) as HTMLInputElement;

		if (datePickerInput) {
			datePickerInput.click();
		}
	}

	cleanDate() {
		this.initialDate = null;
		this.created_at_from_date_complaint = null;
		this.endDate = null;
		this.created_at_to_date_complaint = null;
		this.selectedLabel = 'Todos';
		this.queryComplaints();
	}

	@ViewChild(MatDateRangePicker) dateRangePicker: MatDateRangePicker<Date>;

	public from: Date = null;
	public to: Date = null;

	public minDate: Date;
	public maxDate: Date;

	loadFilter: Boolean;
	public currentDate: any;

	user = {
		phone: '',
		email: '',
		role: '',
		gender: '',
		name: '',
	};

	private isUserSuper: Boolean;
	denounces: Denounce[] = [];
	searchForm: FormGroup;
	complaints: Denounce;
	users: [any?] = [];
	homeDenounces;

	usuariosReicidencias = [];

	loading$: Observable<boolean>;
	loading = true;
	todos = 'todos';
	displayedColumns: string[] = [
		' ',
		'sublocality',
		'place',
		'date_created',
		'date',
		'type',
	];

	orders = ['sublocality', 'place', 'created_at', 'datetime', 'type'];
	orderBy = ['created_at', 'desc'];

	sublocalityAsc = this.orderBy[0] == 'sublocality' && this.orderBy[1] == 'asc';
	placeAsc = this.orderBy[0] == 'place' && this.orderBy[1] == 'asc';
	dateCreatedAsc = this.orderBy[0] == 'created_at' && this.orderBy[1] == 'asc';
	dateAsc = this.orderBy[0] == 'datetime' && this.orderBy[1] == 'asc';
	typeAsc = this.orderBy[0] == 'type' && this.orderBy[1] == 'asc';

	updateIcons() {
		this.sublocalityAsc =
			this.orderBy[0] == 'sublocality' && this.orderBy[1] == 'asc';
		this.placeAsc = this.orderBy[0] == 'place' && this.orderBy[1] == 'asc';
		this.dateCreatedAsc =
			this.orderBy[0] == 'created_at' && this.orderBy[1] == 'asc';
		this.dateAsc = this.orderBy[0] == 'datetime' && this.orderBy[1] == 'asc';
		this.typeAsc = this.orderBy[0] == 'type' && this.orderBy[1] == 'asc';
	}

	sortData(column: string) {
		if (column == this.orderBy[0]) {
			this.orderBy[1] = this.orderBy[1] == 'asc' ? 'desc' : 'asc';
		} else {
			this.orderBy[0] = column;
			this.orderBy[1] = 'desc';
		}

		this.updateIcons();
		this.queryComplaints();
	}

	dataSource: MatTableDataSource<any>;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	dataSourceDenounces: MatTableDataSource<any>;

	constructor(
		private activeRoute: ActivatedRoute,
		public utilsService: UtilsService,
		private store: Store<AppState>,
		public dialog: MatDialog,
		private fb: FormBuilder,
		private router: Router,
		private toastr: ToastrService,
		private userService: UserService,
		private complaintsService: ComplaintsService,
		private paginatorTranslator: MatPaginatorIntl
	) {}

	dateFilterOp(date: any): void {}

	openInformationEvent(e) {
		let versionClicked = e.currentTarget.classList[2];
		let elements = document.querySelectorAll(`.${versionClicked}`);

		elements[2]?.classList.toggle('show');
		elements[1]?.classList.toggle('rotate');
		elements[0]?.classList.toggle('expand-filter');
		this.setDefaultValues();
	}

	ngOnInit(): void {
		this.translateTable();

		this.searchFilter = new FormGroup({
			typeComplaint: new FormControl(),
			busLine: new FormControl(),
			ocurrenceDate: new FormControl(),
			placeComplaint: new FormControl(),
			sublocalityComplaint: new FormControl(),
			genderComplaint: new FormControl(),
			age: new FormControl(),
		});

		const queryParams = this.activeRoute.snapshot.queryParams;

		this.pageIndex = queryParams.page || 0;
		this.pageSize = queryParams.perPage || 5;

		this.queryComplaints();
		this.getComplaintsRecurrent();
		this.initPassForm();

		this.complaintsService.getDashboardCards().subscribe((res) => {
			this.sublocalities = res.distinct_values?.sublocality;
		});

		this.setDefaultValues();

		this.activeRoute.params.subscribe((params) => {
			this.homeDenounces = params;
		});
		this.isUserSuper = Boolean(localStorage.getItem('superUser'));
		this.getUser();
	}

	translatePlace(place: string): string {
		if (place === 'BUS_STOP') {
			return 'Parada de ônibus';
		} else if (place === 'BUS_TERMINUS') {
			return 'Terminal de ônibus';
		} else if (place === 'BUS') {
			return 'Ônibus';
		} else if (place === 'TERMINAL') {
			return 'Terminal';
		} else if (place == 'OTHERS' || place == 'OTHER'){
			return 'Outros';
		} else if (place == "AT_FESTIVAL") {
			return "No festival";
		} else if (place == "FESTIVAL_SURROUNDINGS") {
			return "Nos arredores do festival";
		} else if (place == "FESTIVAL_BUS") {
			return "Linha de ônibus do festival";
		} else {
			return place;
		}
}

	translateType(type: string): string {
		if (type === 'OTHERS') {
			return 'Outros';
		} else if (type === 'SELF_TOUCH_OR_FLASHING') {
			return 'Se tocou ou mostrou';
		} else if (type === 'GROPING') {
			return 'Encoxar/Apalpar';
		} else if (type === 'STALKING') {
			return 'Perseguição';
		} else if (type === 'COERCION') {
			return 'Intimidação';
		} else if (type === 'UNWANTED_PHOTOS') {
			return 'Foto não autorizada';
		} else if (type === "VERBAL_HARASSMENT") {
			return "Agressão Verbal";
		} else if (type === "PHYSICAL_AGGRESSION") {
			return "Agressão Física";
		} else if (type === "FORCED_KISS") {
			return "Beijo Forçado / Violentaram / Tentaram violentar";
		} else {
			return type;
		}
	}

	seeDetails(id): void {
		this.router.navigate(['/home/ocurrences-details', id]);
	}

	public onInitialDateChange(event: MatDatepickerInputEvent<Date>): void {
		this.initialDate = event.value;
		this.created_at_from_date_complaint = this.initialDate;
		this.barChartLabels = [
			`${this.formatarDataBrasileira(
				this.initialDate
			)} - ${this.formatarDataBrasileira(this.endDate)}`,
		];
		this.selectedLabel = this.barChartLabels[0];
	}

	public onEndDateChange(event: MatDatepickerInputEvent<Date>): void {
		this.endDate = event.value;
		this.created_at_to_date_complaint = this.endDate;
		this.barChartLabels = [
			`${this.formatarDataBrasileira(
				this.initialDate
			)} - ${this.formatarDataBrasileira(this.endDate)}`,
		];
		this.selectedLabel = this.barChartLabels[0];

		if (this.initialDate != null && this.endDate != null) {
			this.from = new Date(
				this.initialDate.getFullYear(),
				this.initialDate.getMonth(),
				this.initialDate.getDate(),
				0,
				0,
				0
			);
			this.to = new Date(
				this.endDate.getFullYear(),
				this.endDate.getMonth(),
				this.endDate.getDate(),
				0,
				0,
				0
			);
			this.queryComplaints();
		}
	}

	initPassForm(): void {
		this.searchForm = this.fb.group({
			search: [''],
		});
	}

	filterComplaint(): void {
		const filter = this.searchForm.value.search;
		this.dataSourceDenounces.filter = filter.toLowerCase();
	}

	splitDescription(theString: string) {
		//return theString[0].split(",")
	}

	getComplaintsRecurrent(): void {
		this.loadFilter = true;
		const busLine = this.searchFilter.controls['busLine'].value;
		const typeComplaintForm = this.searchFilter.controls['typeComplaint'].value;
		const placeComplaintForm =
			this.searchFilter.controls['placeComplaint'].value;
		const dataOcurrenceForm = this.searchFilter.controls['ocurrenceDate'].value;
		const sublocalityComplaintForm =
			this.searchFilter.controls['sublocalityComplaint'].value;

		let translatedType: string = typeComplaintDict[typeComplaintForm];
		let translatedPlace: string = placeComplaintDict[placeComplaintForm];
		this.complaintsService
			.getComplaintsRecurrent(
				busLine,
				translatedType,
				null,
				translatedPlace,
				sublocalityComplaintForm,
				this.user_id_complaint,
				this.created_at_from_date_complaint
					? convertToPythonDatetime(this.created_at_from_date_complaint)
					: null,
				this.created_at_to_date_complaint
					? convertToPythonDatetime(this.created_at_to_date_complaint)
					: null
			)
			.subscribe((complaints) => {
				this.usuariosReicidencias = complaints.recurrent_users;
				this.loadFilter = false;
			});

		this.showFilters = false;
	}

	private portugueseRangeLabel(
		page: number,
		pageSize: number,
		length: number
	): string {
		if (length === 0 || pageSize === 0) {
			return `0 de ${length}`;
		}

		length = Math.max(length, 0);

		const startIndex = page * pageSize;

		const endIndex =
			startIndex < length
				? Math.min(startIndex + pageSize, length)
				: startIndex + pageSize;

		return `${startIndex + 1} - ${endIndex} de ${length}`;
	}

	private translateTable() {
		this.paginatorTranslator.itemsPerPageLabel = 'Itens por página:';
		this.paginatorTranslator.nextPageLabel = 'Página seguinte';
		this.paginatorTranslator.previousPageLabel = 'Página anterior';
		this.paginatorTranslator.firstPageLabel = 'Primeira página';
		this.paginatorTranslator.lastPageLabel = 'Última página';
		this.paginatorTranslator.getRangeLabel = this.portugueseRangeLabel;
	}

	private updateComplaintOnStore(): void {
		this.store.dispatch(fromComplaintsActions.loadComplaints());
	}

	public deleteComplaint(denounce: any): void {
		this.complaintsService
			.deleteComplaint(denounce._id)
			.subscribe()
			.add(() => {
				this.updateComplaintOnStore(); // update list complaint
				this.toastr.success('Denúncia deletada com sucesso!');
			});
	}
	public deleteComplaintFunc(data): void {
		const dialog = this.dialog.open(ComplaintConfirmationDeleteComponent, {
			panelClass: 'media-modal',
			width: '40%',
		});

		dialog.afterClosed().subscribe((response) => {
			if (response === true) {
				this.deleteComplaint(data);
			}
		});
	}

	getUser(): void {
		this.userService.getSelfUserOp().subscribe((userAtt) => {
			userAtt.UserAttributes.forEach((att) => {
				if (att.Name === 'phone_number') {
					this.user.phone = att.Value;
				} else if (att.Name === 'name') {
					this.user.name = att.Value;
				} else if (att.Name === 'gender') {
					this.user.gender = att.Value;
				} else if (att.Name === 'email') {
					this.user.email = att.Value;
				} else if (att.Name === 'custom:role') {
					this.user.role = att.Value;
				}
			});
			this.loading$ = this.store.pipe(
				select(fromComplaintsSelector.selectLoading)
			);
		});
	}

	setDefaultValues(): void {
		this.searchFilter!.controls['typeComplaint']!.setValue('Todos');
		this.searchFilter!.controls['busLine']!.setValue('Todos');
		this.searchFilter!.controls['placeComplaint']!.setValue('Todos');
		this.searchFilter!.controls['sublocalityComplaint']!.setValue('Todos');
		this.searchFilter!.controls['ocurrenceDate']!.setValue('Todos');
		this.searchFilter!.controls['genderComplaint']!.setValue('Todos');
		this.searchFilter!.controls['age']!.setValue('Todos');
		this.created_at_from_date_complaint = null;
		this.created_at_to_date_complaint = null;
	}

	limparFiltros(): void {
		this.setDefaultValues();
		this.queryComplaints();
		this.showFilters = false;
	}

	limparId(): void {
		this.user_id_complaint = null;
		this.queryComplaints();
	}

	capturarID(id): void {
		this.user_id_complaint = id;
		this.queryComplaints();
	}

	selectedFilters = [];

	removeFilter(filter): void {
		let index = this.selectedFilters.findIndex((f) => f.name == filter.name);

		this.selectedFilters.splice(index, 1);
		this.searchFilter.controls[filter.filter].setValue('Todos');

		this.queryComplaints();
	}

	queryComplaints(): void {
		this.selectedFilters = [];

		this.loadFilter = true;
		const busLine = this.searchFilter.controls['busLine'].value;
		const typeComplaintForm = this.searchFilter.controls['typeComplaint'].value;
		const placeComplaintForm =
			this.searchFilter.controls['placeComplaint'].value;
		const dataOcurrenceForm = this.searchFilter.controls['ocurrenceDate'].value;
		const sublocalityComplaintForm =
			this.searchFilter.controls['sublocalityComplaint'].value;
		const genderComplaintForm =
			this.searchFilter.controls['genderComplaint'].value;

		const ageForm = this.searchFilter.controls['age'].value;

		const translationDict = {
			WOMAN_TRANS: 'Mulher trans',
			WOMAN_CIS: 'Mulher cis',
			MAN_TRANS: 'Homem trans',
			MAN_CIS: 'Homem cis',
			NON_BINARY: 'Não binário',
		};

		if (busLine && busLine != 'Todos')
			this.selectedFilters.push({ name: busLine, filter: 'busLine' });
		if (typeComplaintForm && typeComplaintForm != 'Todos')
			this.selectedFilters.push({
				name: typeComplaintForm,
				filter: 'typeComplaint',
			});
		if (placeComplaintForm && placeComplaintForm != 'Todos') {
			this.selectedFilters.push({
				name: placeComplaintForm,
				filter: 'placeComplaint',
			});
		}
		if (sublocalityComplaintForm && sublocalityComplaintForm != 'Todos')
			this.selectedFilters.push({
				name: sublocalityComplaintForm,
				filter: 'sublocalityComplaint',
			});
		if (genderComplaintForm && genderComplaintForm != 'Todos')
			this.selectedFilters.push({
				name: translationDict[genderComplaintForm],
				filter: 'genderComplaint',
			});

		if (ageForm && ageForm != 'Todos')
			this.selectedFilters.push({ name: ageForm, filter: 'age' });

		let paginate: boolean = true;
		let details: boolean = false;
		let translatedType: string = typeComplaintDict[typeComplaintForm];
		let translatedPlace: string = placeComplaintDict[placeComplaintForm];

		this.complaintsService
			.getComplaints({
				paginate: paginate,
				details: details,
				bus_name: busLine,
				type: translatedType,
				occurence_date: null,
				place_complaint: translatedPlace,
				sublocality_complaint: sublocalityComplaintForm,
				user_id_complaint: this.user_id_complaint,
				created_at_from_date_complaint: this.created_at_from_date_complaint
					? convertToPythonDatetime(this.created_at_from_date_complaint)
					: null,
				created_at_to_date_complaint: this.created_at_to_date_complaint
					? convertToPythonDatetime(this.created_at_to_date_complaint)
					: null,
				atMoment: null,
				orderBy: this.orderBy,
				gender: genderComplaintForm,
				age: ageForm,
			})
			.subscribe((res) => {
				const complaints = res.complaints;
				this.denounces = [...complaints];
				this.dataSource = new MatTableDataSource<any>(this.denounces);
				this.dataSourceDenounces = new MatTableDataSource<any>(this.denounces);
				this.paginator.pageIndex = this.pageIndex;
				this.paginator.pageSize = this.pageSize;
				this.dataSourceDenounces.paginator = this.paginator;
			});

		this.getComplaintsRecurrent();
	}

	changePage(event): void {
		this.pageIndex = event.pageIndex;
		this.pageSize = event.pageSize;

		this.router.navigate([], {
			queryParams: {
				page: this.pageIndex,
				perPage: this.pageSize,
			},
			queryParamsHandling: 'merge',
		});
	}

	formatarDataBrasileira(data) {
		if (data) {
			const dia = String(data.getDate()).padStart(2, '0');
			const mes = String(data.getMonth() + 1).padStart(2, '0');
			const ano = data.getFullYear();
			return `${dia}/${mes}/${ano}`;
		} else {
			return '';
		}
	}
}

function removeDuplicates(strings) {
	const uniqueStrings = [];

	for (const str of strings) {
		if (!uniqueStrings.includes(str)) {
			uniqueStrings.push(str);
		}
	}

	return uniqueStrings;
}

function convertToPythonDatetime(date) {
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString().padStart(2, '0');
	const hours = date.getHours().toString().padStart(2, '0');
	const minutes = date.getMinutes().toString().padStart(2, '0');
	const seconds = date.getSeconds().toString().padStart(2, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
